<template>
  <section class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Články - Typy - Nabídka - Přidat</strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="Název"
          :validate-status="error('ale_name') ? 'error' : ''"
          :help="error('ale_name') || ''"
        >
          <a-input placeholder="Název" v-decorator="['ale_name', {rules: [{max: 60, message: 'Název nemůže být delší než 100 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          :required="true"
          label="Obrázek"
        >
          <a-row class="pb-5" type="flex" justify="center">
            <a-col :span="8">
              <a-input-search
                placeholder="Hledat..."
                v-model="image.search"
              />
            </a-col>
          </a-row>
          <div v-if="images.data.length > 0">
            <a-row>
              <a-radio-group v-decorator="['existing']" name="image" :class="$style.gallery">
                <a-col v-if="image.selected !== undefined" :xl="4" :md="6" :sm="8" :xs="12">
                  <div :class="{[$style.active]: image.selected.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                    <img v-if="!image.errors.includes(image.selected.iae_id)" class="img-fluid" :src="$uploadImagePath + image.selected.iae_path + '_6.' + image.selected.iae_format" @error="image.errors.push(image.selected.iae_id)">
                    <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                    <div :class="$style.itemControls">
                      <span :class="$style['item-name']">{{ toImageName(image.selected.iae_name) }}</span>
                      <a-radio :class="$style['ant-radio-wrapper']" :value="image.selected.iae_id" />
                    </div>
                  </div>
                </a-col>
                <a-col :key="'all'+index" v-for="(item, index) in images.data" :xl="4" :md="6" :sm="8" :xs="12">
                  <div :class="{[$style.active]: item.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                    <img v-if="!image.errors.includes(item.iae_id)" class="img-fluid" :src="$uploadImagePath + item.iae_path + '_6.' + item.iae_format" @error="image.errors.push(item.iae_id)">
                    <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                    <div :class="$style.itemControls">
                      <span :class="$style['item-name']">{{ toImageName(item.iae_name) }}</span>
                      <a-radio :class="$style['ant-radio-wrapper']" :value="item.iae_id"/>
                    </div>
                  </div>
                </a-col>
              </a-radio-group>
            </a-row>
            <a-row class="pb-5 pt-5" type="flex" justify="center">
              <a-col :span="8">
                <a-button v-if="imageNextCount > 0" type="primary" class="width-200 d-block m-auto" @click="onNextImagesClick">Načíst další...</a-button>
              </a-col>
            </a-row>
          </div>
          <a-empty v-else>
            <a-spin v-if="!image.loaded" />
          </a-empty>
        </a-form-item>

        <a-form-item
          label="Nadpis odznaku"
          :validate-status="error('badge_title') ? 'error' : ''"
          :help="error('badge_title') || ''"
        >
          <a-input placeholder="Nadpis odznak" v-decorator="['badge_title', {rules: [{required: form.getFieldValue('badge_content') !== undefined && form.getFieldValue('badge_content').trim().length > 0, message: 'Nadpis odznak musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Obsah odznaku"
          :validate-status="error('badge_content') ? 'error' : ''"
          :help="error('badge_content') || ''"
        >
          <a-input placeholder="Obsah odznaku" v-decorator="['badge_content', {rules: [{required: form.getFieldValue('badge_title') !== undefined && form.getFieldValue('badge_title').trim().length > 0, message: 'Obsah odznaku musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis tlačítka"
          :validate-status="error('button_title') ? 'error' : ''"
          :help="error('button_title') || ''"
        >
          <a-input placeholder="Nadpis tlačítka" v-decorator="['button_title', {rules: [{required: form.getFieldValue('button_link') !== undefined && form.getFieldValue('button_link').trim().length > 0, message: 'Nadpis tlačítka musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Odkaz tlačítka"
          :validate-status="error('button_link') ? 'error' : ''"
          :help="error('button_link') || ''"
        >
          <a-input placeholder="Odkaz tlačítka" v-decorator="['button_link', {rules: [{required: form.getFieldValue('button_title') !== undefined && form.getFieldValue('button_title').trim().length > 0, message: 'Odkaz tlačítka musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis tučně"
          :validate-status="error('ale_title') ? 'error' : ''"
          :help="error('ale_title') || ''"
        >
          <a-input placeholder="Nadpis tučně" v-decorator="['ale_title', {rules: [{max: 60, message: 'Nadpis tučně nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis kurzivou"
          :validate-status="error('ale_title_thin') ? 'error' : ''"
          :help="error('ale_title_thin') || ''"
        >
          <a-input placeholder="Nadpis kurzivou" v-decorator="['ale_title_thin', {rules: [{max: 60, message: 'Nadpis kurzivou nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Popisek"
          :validate-status="error('ale_description') ? 'error' : ''"
          :help="error('ale_description') || ''"
        >
          <a-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
            placeholder="Popisek"
            v-decorator="['ale_description']"
          />
        </a-form-item>

        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['ale_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <a-form-item label="Přidat mezeru pod článek?">
          <a-checkbox v-decorator="['gap', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Přidat</a-button>
        </div>
      </a-form>
    </div>
  </section>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: {
    ActionTools, LanguageTab,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/article/type/doy',
          title: 'Seznam',
        },
      ],
      item: {
        languages: [],
      },
      image: {
        search: '',
        page: 1,
        loaded: false,
        trigger: false,
        errors: [],
        selected: undefined,
      },
      formItemLayout: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      loaded: [],
    }
  },
  computed: {
    images: function () {
      const items = this.$store.getters['image/filteredItems']({ searchText: this.image.search, page: this.image.page })
      if (this.image.selected !== undefined) {
        const filteredData = items.data.filter(x => x.iae_id !== this.image.selected.iae_id)
        return { count: items.count - (items.data.length - filteredData.length), data: filteredData }
      }
      return items
    },
    imageNextCount: function () {
      const imageCount = this.images.count - this.images.data.length
      return imageCount > 6 ? 6 : imageCount
    },
    language: function () {
      return this.$store.getters['language/active']
    },
  },
  methods: {
    toImageName: function (name) {
      const maxLength = 30
      const nameSubstring = name.substring(0, maxLength)
      return nameSubstring.length !== maxLength ? nameSubstring : nameSubstring + '...'
    },
    onNextImagesClick() {
      this.image.page += 1
    },
    initData() {
      Promise.all([
        this.$store.dispatch('image/getList'),
      ])
        .catch(() => {})
        .finally(() => {
          this.loaded.push(this.language)
          this.image.loaded = true
        })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('article/post', this.getData())
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getData() {
      return {
        ate_type: 'DOY',
        languages: this.item.languages.filter(x => x.ale_name !== undefined && x.ale_name.trim().length > 0).map(x => {
          return {
            lge_id: x.lge_id,
            ale_title_thin: x.ale_title_thin !== undefined ? x.ale_title_thin : null,
            ale_content: x.ale_content,
            ale_description: x.ale_description !== undefined ? x.ale_description : null,
            ale_title: x.ale_title !== undefined ? x.ale_title : null,
            ale_name: x.ale_name !== undefined ? x.ale_name : null,
            ale_is_active: x.ale_is_active,
          }
        }),
      }
    },
    handleChange(oldLanguage) {
      const foundObj = { article: false }
      let image
      if (this.form.getFieldValue('existing') !== undefined) {
        image = this.$store.getters['image/getImageById'](this.form.getFieldValue('existing'))
      }
      const newObj = {
        article: {
          lge_id: oldLanguage,
          ale_title_thin: this.form.getFieldValue('ale_title_thin'),
          ale_content: {
            gap: this.form.getFieldValue('gap'),
            image: image,
            badge: { title: this.form.getFieldValue('badge_title'), content: this.form.getFieldValue('badge_content') },
            button: { title: this.form.getFieldValue('button_title'), link: this.form.getFieldValue('button_link') },
          },
          ale_description: this.form.getFieldValue('ale_description'),
          ale_title: this.form.getFieldValue('ale_title'),
          ale_name: this.form.getFieldValue('ale_name'),
          ale_is_active: this.form.getFieldValue('ale_is_active'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.article
          foundObj.article = true
          return true
        }
      })
      if (!foundObj.article) {
        this.item.languages.push(newObj.article)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
  },
  created() {
    this.initData()
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        const foundObj = { article: this.item.languages.find(x => x.lge_id === newValue) }
        let newObj
        if (foundObj.article === undefined) {
          newObj = {
            ale_title_thin: undefined,
            ale_description: undefined,
            ale_title: undefined,
            ale_name: undefined,
            ale_is_active: true,
            gap: true,
            existing: undefined,
            badge_title: undefined,
            badge_content: undefined,
            button_title: undefined,
            button_link: undefined,
          }
          this.image.selected = undefined
        } else {
          newObj = {
            ale_title_thin: foundObj.article.ale_title_thin,
            gap: foundObj.article.ale_content.gap,
            ale_description: foundObj.article.ale_description,
            ale_title: foundObj.article.ale_title,
            ale_name: foundObj.article.ale_name,
            ale_is_active: foundObj.article.ale_is_active,
            existing: foundObj.article.ale_content.image === undefined ? undefined : foundObj.article.ale_content.image.iae_id,
            badge_title: foundObj.article.ale_content.badge !== undefined && foundObj.article.ale_content.badge !== null ? foundObj.article.ale_content.badge.title : undefined,
            badge_content: foundObj.article.ale_content.badge !== undefined && foundObj.article.ale_content.badge !== null ? foundObj.article.ale_content.badge.content : undefined,
            button_title: foundObj.article.ale_content.button !== undefined && foundObj.article.ale_content.button !== null ? foundObj.article.ale_content.button.title : undefined,
            button_link: foundObj.article.ale_content.button !== undefined && foundObj.article.ale_content.button !== null ? foundObj.article.ale_content.button.link : undefined,
          }
          this.image.selected = foundObj.article.ale_content.image === undefined ? undefined : foundObj.article.ale_content.image
        }
        this.form.getFieldDecorator('existing')
        this.form.setFieldsValue(newObj)
        this.image.trigger = !this.image.trigger
        this.form.validateFields()
      }
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
